<template>
  <div class="detect-alert-dailog col-block">
    <div class="detect-alert-main-container col-block">
      <div class="detect-alert-main-content" v-html="$t('COMPONENT.dialog.detectAlert.___content', { target: $t(currentRegion.title) })"></div>
    </div>
    <div :style="{ height: '10px' }"></div>
    <div class="detect-alert-setting-container col-block">
      <div class="detect-alert-setting-block row-block" @click="e => saveSetting = !saveSetting">
        <img :src="saveSetting ? require('@/assets/images/checkbox-true.svg') : require('@/assets/images/checkbox-false.svg')" alt="">
        <div :style="{ width: '8px' }"></div>
        <div class="detect-alert-setting-title-container row-block">
          <div class="detect-alert-setting-title">
            <span>{{ $t('COMPONENT.dialog.detectAlert.setting.___title') }}</span>
            <span>{{ ' (' }}</span>
            <a class="link" @click.stop="e => clearSetting()">{{ $t('COMPONENT.dialog.detectAlert.setting.___clear') }}</a>
            <span>{{ ')' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '30px' }"></div>
    <div class="detect-alert-button-container row-block">
      <button class="cancel-outline-button circle-button center-block" @click="e => $emit('closeModal')">
        <span>{{ $t('COMPONENT.dialog.detectAlert.button.___another') }}</span>
      </button>
      <button class="main-button circle-button center-block" @click="e => siteOnSelected()">
        <span>{{ $t('COMPONENT.dialog.detectAlert.button.___enter') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import { regionOptions } from '@/constants/global/data'

export default {
  props: {
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      saveSetting: false
    }
  },
  computed: {
    currentRegion () {
      return regionOptions.find(option => option.value === this.params.region)
    }
  },
  methods: {
    siteOnSelected () {
      this.params.func['siteOnSelected'](this.currentRegion, this.saveSetting)
    },
    clearSetting () {
      this.params.func['clearSetting']()
      this.$emit('closeModal')
    }
  }
}
</script>
